import {strEnum} from "../../types";

export const RATING_FILTER_SORT = strEnum([
    "ascending",
    "descending"
]);

export type RATING_FILTER_SORT = keyof typeof RATING_FILTER_SORT;

export const TCI_RATINGS_COMPONENT_MODE = strEnum([
    "LIST_FILTER_SELECT",
    "LIST_READ_ONLY",
    "DETAIL_READ_ONLY",
    "DETAIL_EDIT"
]);
export type TCI_RATINGS_COMPONENT_MODE = keyof typeof TCI_RATINGS_COMPONENT_MODE;

export class TCIRatingsDisplaySize {
    public static TINY = new TCIRatingsDisplaySize(100, 100);
    public static SMALL = new TCIRatingsDisplaySize(100, 100);
    public static MEDIUM = new TCIRatingsDisplaySize(100, 100);
    public static LARGE = new TCIRatingsDisplaySize(100, 100);
    public static XLARGE = new TCIRatingsDisplaySize(100, 100);

    private constructor(private width: number, private height: number) {
    }
}

export const TCI_RATING_MODEL = strEnum([
    "Rating",
    "Like"
]);

export type TCI_RATING_MODEL = keyof typeof TCI_RATING_MODEL;

/**
 * ITCIRating
 */
export interface ITCIRating {
    /**
     * number of ticks for this rating 1
     */
    r1_count: number;
    /**
     * number of ticks for this rating 2
     */
    r2_count: number;
    /**
     * number of ticks for this rating 3
     */
    r3_count: number;
    /**
     * number of ticks for this rating 4
     */
    r4_count: number;
    /**
     * number of ticks for this rating 5
     */
    r5_count: number;
}


export class ITCIRatingScore {
    val: number;
}

/**
 * TCIRatingScore
 */
export class TCIRatingScore implements ITCIRatingScore {


    public static ZERO = new TCIRatingScore(0);
    public static ONE = new TCIRatingScore(1);
    public static TWO = new TCIRatingScore(2);
    public static THREE = new TCIRatingScore(3);
    public static FOUR = new TCIRatingScore(4);
    public static FIVE = new TCIRatingScore(5);

    public val: number;

    private constructor(value: number) {
        this.setRatingValue(value);
    }

    /**
     * getRatingFromNumber
     * @param num
     */
    public static getRatingFromNumber(num: number): TCIRatingScore {
        if (num <= TCIRatingScore.ZERO.getRatingValue()) {
            return TCIRatingScore.ZERO;
        } else if (num >= TCIRatingScore.FIVE.getRatingValue()) {
            return TCIRatingScore.FIVE;
        } else {
            const rval = Math.round(num);
            return new TCIRatingScore(rval);
        }
    }

    /**
     * Return a rating value to single decimal place
     * @param ratings
     */
    public static calculateWeightedAvgRating(ratings: ITCIRating): number {
        let wavg = ratings.r1_count * TCIRatingScore.ONE.getRatingValue() +
            ratings.r2_count * TCIRatingScore.TWO.getRatingValue() +
            ratings.r3_count * TCIRatingScore.THREE.getRatingValue() +
            ratings.r4_count * TCIRatingScore.FOUR.getRatingValue() +
            ratings.r5_count * TCIRatingScore.FIVE.getRatingValue();
        wavg = wavg / (ratings.r1_count + ratings.r2_count + ratings.r3_count + ratings.r4_count + ratings.r5_count);
        return Math.round(wavg * 10) / 10;
    }

    /**
     * setRatingValue
     * @param num
     * @private
     */
    private setRatingValue(num: number): void {
        if (num <= 0) {
            this.val = 0;
            return;
        } else if (num >= 5) {
            this.val = 5;
            return;
        } else {
            this.val = Math.round(num);
        }
    }

    /**
     * getRatingValue
     */
    public getRatingValue(): number {
        return this.val;
    }
}


/**
 * ITCIRatingComment
 */
export interface ITCIRatingComment extends ITCIRatingScore {
    /**
     * comment string
     */
    comment: string;
    /**
     * comment timestamp
     */
    comment_dt: number;
}

/**
 * ITCIRatingCommentsMap
 */
// export interface ITCIRatingCommentsMap {
//     /**
//      * unique uuid key
//      */
//     [commentId: string]: ITCIRatingComment;
// }

/**
 * ITCIRateAble
 */
export interface ITCIRateAble {
    // /**
    //  * score by the logged in user during load
    //  */
    // rating?: ITCIRatingScore;
    // /**
    //  * score given by the logged in user after change
    //  */
    // newRating?: ITCIRatingScore;
    /**
     * Rating counts
     */
    ratings?: ITCIRating;
    // /**
    //  * comment by the logged in user during load
    //  */
    // ratingComments?: ITCIRatingCommentsMap;
    // /**
    //  * Comments added
    //  */
    // ratingCommentsAdded?: ITCIRatingCommentsMap;
    // /**
    //  * Comments Removed
    //  */
    // ratingCommentsRemoved?: ITCIRatingCommentsMap;

}

/**
 * ITCILikes
 */
export interface ITCILikes {
    likeCount: number;
}

/**
 * ITCILikeAble
 */
export interface ITCILikeAble {
    likes?: ITCILikes;
}

/**
 * ITCILike
 */
export interface ITCILike {
    val: boolean;
    comment?: string;
}

/**
 * ITCICardLikes used for updating the card likes when user changes the like status for any connector in the detial view
 */
export interface ITCICardLikes {
    likes: number;
    connectorId: string;
}

/**
 * TCILike
 */
export class TCILike implements ITCILike {

    private constructor(public val: boolean) {
    }

    public static LIKE = new TCILike(true);
    public static UNLIKE = new TCILike(false);

    public static getLike(bval: boolean): TCILike {
        return bval ? TCILike.LIKE : TCILike.UNLIKE;
    }

    getValue(): boolean {
        return this.val;
    }
}

/**
 * Constants for NgRatingsComponent component
 */
export const MAX_RATING_COUNT = 5;

